import './press-registration.scss';

/**
 * version    1.0
 * class      <type> (press registration)
 * classdesc  Component that manage the press registration form
 */
export class PressRegistration {}
